/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateUnitCapabilitiesRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateUnitCapabilitiesResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateUnitCapabilities = (request: UpdateUnitCapabilitiesRequest, options?: CashRequestOptions) => post<UpdateUnitCapabilitiesRequest, UpdateUnitCapabilitiesResponse>("/2.0/cash/update-unit-capabilities", request, {...options, rejectOnError: true })